import {
  BOOLEAN_OPERATORS,
  DATE_OPERATORS,
  ENUM_OPERATORS,
  QueryFieldDefinition,
  TEXT_OPERATORS,
} from './types'

/** Queryable fields for the PROJECT module. */
export const PROJECT_QUERY_FIELDS: QueryFieldDefinition[] = [
  {
    key: 'text',
    label: 'Text',
    type: 'text',
    description: 'Searches name, description and project code',
    example: 'text ~ "website"',
    operators: ['~', '!~'],
  },
  {
    key: 'name',
    aliases: ['title'],
    label: 'Name',
    type: 'text',
    example: 'name ~ "redesign"',
    operators: TEXT_OPERATORS,
    sortable: true,
  },
  {
    key: 'description',
    label: 'Description',
    type: 'text',
    operators: ['~', '!~', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'code',
    aliases: ['key'],
    label: 'Project code',
    type: 'text',
    example: 'code = WEB',
    operators: ['=', '!=', '~', 'IN', 'NOT IN', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'status',
    label: 'Status',
    type: 'enum',
    description: 'Matches status name or id (e.g. "On Hold", active)',
    example: 'status = active',
    operators: ENUM_OPERATORS,
    optionSource: 'statuses',
    sortable: true,
  },
  {
    key: 'entity',
    aliases: ['client', 'company'],
    label: 'Entity',
    type: 'reference',
    description: 'Matches the owning entity by name',
    example: 'entity = "Acme Corp"',
    operators: ENUM_OPERATORS,
    optionSource: 'entities',
  },
  {
    key: 'creator',
    aliases: ['createdBy', 'owner'],
    label: 'Creator',
    type: 'user',
    example: 'creator = currentUser()',
    operators: ['=', '!=', 'IN', 'NOT IN', 'IS EMPTY', 'IS NOT EMPTY'],
    optionSource: 'members',
    supportsCurrentUser: true,
  },
  {
    key: 'member',
    aliases: ['teamMember'],
    label: 'Project member',
    type: 'user',
    description: 'Projects where the person is a member',
    example: 'member = currentUser()',
    operators: ['=', '!=', 'IN', 'NOT IN'],
    optionSource: 'members',
    supportsCurrentUser: true,
  },
  {
    key: 'type',
    aliases: ['projectType'],
    label: 'Project type',
    type: 'enum',
    example: 'type = BASIC',
    operators: ENUM_OPERATORS,
  },
  {
    key: 'isTemplate',
    aliases: ['template'],
    label: 'Is template',
    type: 'boolean',
    operators: BOOLEAN_OPERATORS,
  },
  {
    key: 'startDate',
    aliases: ['start'],
    label: 'Start date',
    type: 'date',
    example: 'startDate >= startOfMonth()',
    operators: DATE_OPERATORS,
    sortable: true,
  },
  {
    key: 'endDate',
    aliases: ['end'],
    label: 'End date',
    type: 'date',
    example: 'endDate <= endOfMonth()',
    operators: DATE_OPERATORS,
    sortable: true,
  },
  {
    key: 'created',
    aliases: ['createdAt'],
    label: 'Created date',
    type: 'date',
    example: 'created >= -90d',
    operators: DATE_OPERATORS,
    sortable: true,
  },
  {
    key: 'updated',
    aliases: ['updatedAt'],
    label: 'Updated date',
    type: 'date',
    operators: DATE_OPERATORS,
    sortable: true,
  },
]
